import { isNil } from "lodash-es";
import { softContains } from "../../utils/stringUtil.ts";
import { keyFromSelector } from "i18next";
import type { LanguageCode } from "../../state/i18n.tsx";
import type { Template } from "../../types/Template.ts";

export const templateFilters = [
  { translationKey: keyFromSelector(($) => $.TEMPLATES_FILTER_ALL), value: "ALL" },
  { translationKey: keyFromSelector(($) => $.TEMPLATES_FILTER_MOST_POPULAR), value: "MOST_POPULAR" },
  { translationKey: keyFromSelector(($) => $.TEMPLATES_FILTER_CONSTRUCTION), value: "CONSTRUCTION" },
  { translationKey: keyFromSelector(($) => $.TEMPLATES_FILTER_INSTALLATION), value: "INSTALLATION" },
  { translationKey: keyFromSelector(($) => $.TEMPLATES_FILTER_ENERGY_UTILITIES), value: "ENERGY_UTILITIES" },
  { translationKey: keyFromSelector(($) => $.TEMPLATES_FILTER_MANUFACTURING), value: "MANUFACTURING" },
  { translationKey: keyFromSelector(($) => $.TEMPLATES_FILTER_FACILITY), value: "FACILITY" },
  { translationKey: keyFromSelector(($) => $.TEMPLATES_FILTER_SAFETY), value: "SAFETY" },
  { translationKey: keyFromSelector(($) => $.TEMPLATES_FILTER_AUTOMOTIVE), value: "AUTOMOTIVE" },
  { translationKey: keyFromSelector(($) => $.TEMPLATES_FILTER_INFRASTRUCTURE), value: "INFRASTRUCTURE" },
  { translationKey: keyFromSelector(($) => $.TEMPLATES_FILTER_REAL_ESTATE), value: "REAL_ESTATE" },
  { translationKey: keyFromSelector(($) => $.TEMPLATES_FILTER_LOGISTICS), value: "LOGISTICS" },
  { translationKey: keyFromSelector(($) => $.TEMPLATES_FILTER_OTHER), value: "OTHER" },
  { translationKey: keyFromSelector(($) => $.TEMPLATES_FILTER_CUSTOM), value: "CUSTOM" },
] as const;

export type TemplateFilter = (typeof templateFilters)[number]["value"];

export const getAvailableTemplates = (
  templates: Template[] | undefined,
  filter: TemplateFilter,
  query: string | undefined,
  language: LanguageCode,
) => {
  if (isNil(templates)) {
    return [];
  }

  return templates.filter((t) => {
    if (isNil(t.publishedVersion)) {
      return false;
    }

    if (filter !== "ALL" && !t.meta.tags.includes(filter)) {
      return false;
    }

    const matchesQuery =
      softContains(t.meta.name, query) || (!isNil(t.meta.description) && softContains(t.meta.description, query));

    if (!matchesQuery) {
      return false;
    }

    return softContains(t.meta.language.split("-")[0], language);
  });
};
